module.exports = __webpack_public_path__ + "img/boolflix_logo.14067595.png";